import React from 'react'
import { Link } from 'react-router-dom'

/**
 * This is the dynamic tag component used Headlines, Tags, Footnotes, Preline elements
 */

type DynamicLinkTypes = {
  href: string
  openInNewTab?: boolean
  isExternalLink?: boolean
  children: any
  onClick?: () => void
}

const DynamicLink: React.FC<DynamicLinkTypes> = ({
  children,
  href,
  openInNewTab = false,
  isExternalLink = false,
  ...rest
}: DynamicLinkTypes): JSX.Element => {
  const params = {
    pathname: href
  }
  return isExternalLink ? (
    <a href={href} target={openInNewTab ? '_blank' : '_self'} {...rest}>
      {children}
    </a>
  ) : (
    <Link to={params} target={openInNewTab ? '_blank' : '_self'} {...rest}>
      {children}
    </Link>
  )
}

export default DynamicLink
